(function () {
  var gate = document.getElementById('age-gate');
  if (!gate) return;
  var KEY = 'fbombz_age_ok';
  var ok = false;
  try { ok = window.localStorage.getItem(KEY) === '1'; } catch (e) {}
  if (!ok && !/\/challenge|\/password/.test(location.pathname)) {
    gate.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var yes = gate.querySelector('[data-age-yes]');
    if (yes) yes.focus();
  }
  gate.addEventListener('click', function (e) {
    if (e.target.closest('[data-age-yes]')) {
      try { window.localStorage.setItem(KEY, '1'); } catch (err) {}
      gate.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
    if (e.target.closest('[data-age-no]')) {
      gate.classList.add('is-denied');
    }
  });
})();
